jQuery(window).load(function() {
	
	jQuery('body').addClass('loaded');
	
});


jQuery( ".mobile-toggle button" ).click(function() {
	
  jQuery( ".top-nav" ).toggleClass( 'menu-open' );
  
});